import React, {Component, Fragment} from 'react'
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Form,
    Label,
    CardHeader,
    Input,
} from 'reactstrap'
import Select from 'react-select'
import autobind from 'auto-bind'

import CustomSelectInput from 'components/CustomSelectInput'

import * as API from 'SDK/api'

export default class ScrapPicker extends Component {
    id = 'ScrapPicker'
    field = 'selectedScrap'
    constructor(props) {
        super(props)
        autobind(this)

        const initialValue =
            this.props && this.props.existing
                ? this.props.existing.map((state) => {
                      return {label: state, value: state}
                  })
                : []

        this.state = {
            widgets: [],
            selectedStates: initialValue,
            color: 'rgb(215,215,215)',
            reasoncodes: [],
        }

        if (this.props && this.props.cb) {
            this.props.cb('selectedScrap', initialValue)
        }
    }

    async componentWillMount() {
        await this.getScrapCodes()
    }

    async getScrapCodes() {
        try {
            const scrapCodes = await API.get('scrapcodes', 2)
            this.setState({
                scrapCodes: scrapCodes.map((code) => {
                    return {
                        value: code.reason,
                        label: `${code.category} > ${code.reason}`,
                    }
                }),
            })
        } catch (error) {
            console.log('Could not load scrap', error)
        }
    }

    render() {
        return (
            <Fragment>
                <small style={{color: '#dc3545'}}>{this.state.message}</small>
                <label>Available Scrap Codes:</label>
                <Select
                    components={{Input: CustomSelectInput}}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="scrap"
                    isMulti
                    value={this.state.selectedScrapCodes}
                    onChange={(selectedScrap) => {
                        this.setState({selectedScrap})
                        if (this.props && this.props.cb) {
                            this.props.cb(
                                'selectedScrap',
                                selectedScrap.map((scrap) => scrap.value)
                            )
                        }
                    }}
                    options={this.state.scrapCodes}
                />
            </Fragment>
        )
    }
}
